import { Diagram, DiagramEvent } from 'gojs';
import { Observable, Observer } from 'rxjs';

export const fromDiagramEvent = (
  diagram: Diagram,
  name: Parameters<Diagram['addDiagramListener']>[0],
): Observable<DiagramEvent> =>
  new Observable((observer: Observer<DiagramEvent>) => {
    const listener = observer.next.bind(observer);
    diagram.addDiagramListener(name, listener);
    return () => {
      diagram.removeDiagramListener(name, listener);
    };
  });
